<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
<!--      <a-button type="primary" icon="download" @click="handleExportXls('doctor_register_hospital')">导出</a-button>-->
<!--      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">-->
<!--        <a-button type="primary" icon="import">导入</a-button>-->
<!--      </a-upload>-->
<!--      <a-dropdown v-if="selectedRowKeys.length > 0">-->
<!--        <a-menu slot="overlay">-->
<!--          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>-->
<!--        </a-menu>-->
<!--        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>-->
<!--      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleMoney(record)">对账单</a>
<!--          <a-dropdown>-->
<!--            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>-->
<!--            <a-menu slot="overlay">-->
<!--              <a-menu-item>-->
<!--                <a @click="handleDetail(record)">详情</a>-->
<!--              </a-menu-item>-->
<!--              <a-menu-item>-->
<!--                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">-->
<!--                  <a>删除</a>-->
<!--                </a-popconfirm>-->
<!--              </a-menu-item>-->
<!--            </a-menu>-->
<!--          </a-dropdown>-->
        </span>

      </a-table>
    </div>

    <doctor-register-hospital-modal ref="modalForm" @ok="modalFormOk"></doctor-register-hospital-modal>
    <doctor-register-hospital-add-modal ref="doctorRegisterHospitalAdd"></doctor-register-hospital-add-modal>
    <doctor-register-hospital-order-modal ref="doctorRegisterHospitalOrderModal"></doctor-register-hospital-order-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DoctorRegisterHospitalModal from './DoctorRegisterHospitalModal'
  import DoctorRegisterHospitalAddModal from './modules/DoctorRegisterHospitalAddModal'
  import { getAction, httpAction } from '../../api/manage'
  import DoctorRegisterHospitalOrderModal from './modules/DoctorRegisterHospitalOrderModal'
  import JImageUpload from '@/components/jeecg/JImageUpload'
  export default {
    name: 'DoctorRegisterHospitalList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      DoctorRegisterHospitalModal,
      DoctorRegisterHospitalAddModal,
      DoctorRegisterHospitalOrderModal
    },
    data () {
      return {
        description: '渠道列表',
        // 表头
        columns: [
          {
            title:'医院id',
            align:"center",
            dataIndex: 'id'
          },
          {
            title:'医院名称',
            align:"center",
            dataIndex: 'name'
          },
          {
            title:'电话',
            align:"center",
            dataIndex: 'phone'
          },
          {
            title:'地址',
            align:"center",
            dataIndex: 'address'
          },
          {
            title:'分成比例',
            align:"center",
            dataIndex: 'share',
            customRender:function (text) {
              return text + "%"
            }
          },
          {
            title:'创建者',
            align:"center",
            dataIndex: 'createUser'
          }, 
          {
            title:'医院图片',
            align:"center",
            dataIndex: 'hospitalImage',
            scopedSlots: {customRender: 'imgSlot'}
          },
          {
            title:'创建时间',
            align:"center",
            dataIndex: 'createTime',
            customRender:function (text) {
              return !text?"":(text.length>16?text.substr(0,16):text)
            }
          },
          {
            title:'更新者',
            align:"center",
            dataIndex: 'updateUser'
          },
          {
            title:'更新时间',
            align:"center",
            dataIndex: 'updateTime',
            customRender:function (text) {
              return !text?"":(text.length>16?text.substr(0,16):text)
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/doctorRegisterHospital/doctorRegisterHospital/list",
          delete: "/doctorRegisterHospital/doctorRegisterHospital/delete",
          deleteBatch: "/doctorRegisterHospital/doctorRegisterHospital/deleteBatch",
          exportXlsUrl: "/doctorRegisterHospital/doctorRegisterHospital/exportXls",
          importExcelUrl: "doctorRegisterHospital/doctorRegisterHospital/importExcel",
          
        },
        dictOptions:{},
      }
    },
    created() {
    },
    // computed: {
    //   importExcelUrl: function(){
    //     return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    //   },
    // },
    methods: {
      //对账单
      handleMoney(record){
        console.log(record);
        this.$refs.doctorRegisterHospitalOrderModal.open(record);
        this.listModalVisible = false;
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>